import type { CaseDetail } from '../portfolio';

const fujitsuRecruitCase: CaseDetail = {
  id: 'fujitsu-recruit',
  project: 'FUJITSU Recruitment Branding',
  client: 'FUJITSU',
  year: '2022',
  category: 'Brand / CX / UX/UI / Web',
  role: 'Brand Strategy / CX Planning / UX/UI / Web',
  issue: '企業の採用ブランドが、会社の説明に偏り、候補者にとって「働く自分」が具体的にイメージできなかった。',
  challenge: '採用サイトを、企業説明ではなく、候補者が自分のキャリアを想像できる体験へ変えること。',
  insight: '候補者が知りたいのは「会社の歴史」ではなく「この会社で自分がどう働くか」。',
  strategy: '採用ブランドを「働く自分の物語」として再構成し、職種別の体験と導線を設計。',
  experience: '職種別コンテンツ、キャリアの物語、応募導線までを一つの採用体験として構築。',
  output: 'Brand Concept / Web / UX/UI / Content / Communication',
  impact: '候補者の理解深化と、応募意思の向上を実現。',
  images: [
    {
      src: '/assets/migrated/dcd86107c22d4cc5a342.webp',
      caption: 'Webページ案（特設ページWF）— 直感的な操作でパーパスやFujitsuUvanceを知る階層型Web設計、VIとの組み合わせ展開例、画面遷移イメージ',
    },
    {
      src: '/assets/migrated/4ead8bc39c8136e6bc19.webp',
      caption: '告知広告デザイン展開 — 「変えてみない？世界を、一緒に。」SNS・大型広告アイデア、フラッグビジョンツリー概念、FUJITSU Innovative 総括',
    },
    {
      src: '/assets/migrated/ce569c50c8c18d27e0b9.webp',
      caption: '課題解決型JOBモデルとフラッグビジョンツリー — STP分析・CR選定、パーパスの顕在化、ポジション確立と獲得人材の設計',
    },
    {
      src: '/assets/migrated/dcecfca153f974904a32.webp',
      caption: '第六章総括 — 告知広告デザイン展開（SNS告知含む）、階層別レイヤー確認、FUJITSU Innovative Y/Z generation のコミュニケーション設計',
    },
    {
      src: '/assets/migrated/17e6ba7c3b39a5694ac5.webp',
      caption: 'なりたい自分になれる！を可視化するUI UX設計 — ヘプタグラム・エレメント（3D/動的表現）、7 Key Focus Areas と Purpose の可視化',
    },
    {
      src: '/assets/migrated/36080cac579e7928d94e.webp',
      caption: 'キーメッセージ案 — 「変えてみない？世界を、一緒に。」設計意図、別案「無限に君と、変えていく。」、XI・エレメントクリエーティブの必要性',
    },
    {
      src: '/assets/migrated/17836a5f7ab97d6c3095.webp',
      caption: 'XI・エレメントクリエーティブ 設計意図② — ヘプタグラム・エレメントの三次元・動的表現、雪の結晶のように成長・形成されるイメージ',
    },
    {
      src: '/assets/migrated/f974230a46c67aa499d4.webp',
      caption: 'XI 再構築・「エレメントクリエーティブ」の実現 pages 56-59 — 機能・性能・価格にプラス「体験」〜BTCモデル・XI再構築〜ダイアグラム展開',
    },
    {
      src: '/assets/migrated/785abaecf44d87b7780b.webp',
      caption: 'XI・エレメントクリエーティブ 設計意図① page 6 — ヘプタグラム・エレメント（二次元）',
    },
    {
      src: '/assets/migrated/c535ddd972929c682392.webp',
      caption: 'FUJITSU Heptagram Element — なりたい自分になれる！を可視化するUI UX設計（ヘプタグラム・エレメント黒背景大）',
    },
    {
      src: '/assets/migrated/10633f2f996895b36b36.webp',
      caption: '成長フェーズを「動的」に可視化する — さいごに総括（成長フェーズの可視化）pages 階層①〜④',
    },
    {
      src: '/assets/migrated/f2c681abae34b1892839.webp',
      caption: 'Webページ案（特設ページデザインおよび画面遷移イメージ）— 階層①〜④ + 選択UI（新卒/キャリア/障がい者/グループ/募集一覧へ）',
    },
    {
      src: '/assets/migrated/0560cb139087acd4fae4.webp',
      caption: 'Webページ案 — 採用トップページKV「変えてみない？世界を、一緒に。」+ 富士通を知る + ジョブ検索',
    },
    {
      src: '/assets/migrated/68d73b2b36e76a9cdc56.webp',
      caption: 'さいごに 総括 4面 — 横断的に継続して加速させる / 成長フェーズの可視化 / クリエーティブ展開 / ボーダレスな採用活動の実現',
    },
    {
      src: '/assets/migrated/85eb9656c34100214e02.webp',
      caption: 'BTC化ビジネス強化モデル pages 52-55 — BTCモデル・スキルセット思考・ビジネスデザインの根幹・BTCモデルの図式',
    },
    {
      src: '/assets/migrated/76b221ec7ea408fc5dc0.webp',
      caption: 'Webページ案（特設ページWF）— 階層型Web設計：パーパス→7 Key Focus Areas→Fujitsu Uvance→事業フィールド→ジョブ紹介',
    },
    {
      src: '/assets/migrated/fe7c6e750d11ee7c7530.webp',
      caption: 'XI・エレメントクリエーティブの考え方①/② + 設計意図①/② pages 76-79 — 7 Key Focus AreasとHeptagram Elementの詳細設計',
    },
    {
      src: '/assets/migrated/eace9ea741acc4100e82.webp',
      caption: 'XI・エレメントクリエーティブの必要性 page 3 — ターゲット人材へアプローチしながらパーパス・FujitsuUvanceを知ってもらう一貫性のある訴求、Experience Identityとして継続的に機能',
    },
    {
      src: '/assets/migrated/1f20460f92ca07a3c17f.webp',
      caption: 'FUJITSU Innovative Y/Z generation — Co-creation・engagement・Reality⇄future、新結合・共創し合う・共感し行動に移す意欲',
    },
    {
      src: '/assets/migrated/25e63fbff3a44ad96cd8.webp',
      caption: 'さいごに 総括として（階層別のレイヤーで確認させる）— パーパスの顕在化・採用力の向上・XIの構築CR設計・フラッグビジョンツリー・ビジネスデザイナー',
    },
    {
      src: '/assets/migrated/8f70cfb2f25116736978.webp',
      caption: 'ミレニアル世代データ調査 pages 16-19 — 個人投資・デジタルネイティブ思考・情報取得動向・保存する傾向の実態調査',
    },
    {
      src: '/assets/migrated/f58eb8fa64957c7f8f2d.webp',
      caption: '告知広告デザイン展開（SNS告知含む）— FUJITSU recruiting 2023 「変えてみない？世界を、一緒に。」分割型告知ツール案 4パターン',
    },
    {
      src: '/assets/migrated/51260ee7791e5ed49077.webp',
      caption: 'XI・エレメントクリエーティブの考え方① page 4 — 7 Key Focus Areasから着想する「なりたい自分になれるフィールドがあり、そのキャリアがパーパスの実現に繋がる」エレメントクリエーティブ',
    },
    {
      src: '/assets/migrated/b606c19035306c4f2aac.webp',
      caption: 'XI・エレメントクリエーティブの考え方② page 5 — 7 Key Focus Areasから着想する「なりたい自分になれるフィールドがあり、そのキャリアがパーパスの実現に繋がる」エレメントクリエーティブ（黒背景・Heptagram Element）',
    },
    {
      src: '/assets/migrated/d11f0e73c8e0890c16e4.webp',
      caption: 'FUJITSU Innovative Y/Z generation 総括 — Co-creation・engagement・Reality⇄future、新結合・共創し合う・共感し行動に移す意欲（大判単独展開版）',
    },
    {
      src: '/assets/migrated/0cbe579b344b0011a493.webp',
      caption: '告知広告デザイン展開（SNS告知含む）— FUJITSU recruiting 2023 「世界を、一緒に。」ロボットハンド・イエローパターン、分割型告知ツール案',
    },
    {
      src: '/assets/migrated/dfc371b1ecc40169a889.webp',
      caption: '告知広告デザイン展開（SNS告知含む）— FUJITSU recruiting 2023 コラボレーション・レッドグラデーションパターン、分割型告知ツール案',
    },
    {
      src: '/assets/migrated/6cb7128513d5035c07b5.webp',
      caption: '世代分析総括 pages 36-39 — X世代・ミレニアル世代・Z世代の価値観マインド、世代間の特徴整理、FUJITSU Innovative Y/Z generation',
    },
    {
      src: '/assets/migrated/29eee9d11204671b62f1.webp',
      caption: 'VI展開例・Webページ案 pages 84-87 — VIとの組み合わせ展開例、特設ページWF、特設ページデザインおよび画面遷移イメージ',
    },
    {
      src: '/assets/migrated/4ead8bc39c8136e6bc19.webp',
      caption: 'さいごに 総括として（クリエーティブ展開して設計へ）— このクリエーティブでLOOKを踏襲し連動化する、採用ブランディングにおけるXIとして継続的に機能し、社内外の人材獲得方針の一貫した認知拡大を成功に繋げる',
    },
    {
      src: '/assets/migrated/5d89d6f68f6555c3b8e4.webp',
      caption: 'キーメッセージ 別案 — 「無限に君と、変えていく。」キャッチコピー別案、サステナブルの無限性とインフィニティマークを掛け合わせたパターン',
    },
    {
      src: '/assets/migrated/1bf3bac80108996ca938.webp',
      caption: 'なりたい自分になれる！を可視化するUI UX設計 — ヘプタグラム・エレメントの3D階層表現、雪の結晶のように成長・形成されるイメージ、Purposeと7 Key Focus Areasの連動',
    },
    {
      src: '/assets/migrated/15371694b1bbaa474dc8.webp',
      caption: '告知広告デザイン展開（SNS告知含む）— 「変えてみない？世界を、一緒に。」カラフル横長バナー、遊び心のある施策での求職者コミュニケーション、色覚P型シミュレーション',
    },
    {
      src: '/assets/migrated/10aad492405a52e14da7.webp',
      caption: '第二章 パーパスの顕在化 pages 40-43 — 3C分析・Moment of Truth・FUJITSUのビジネススコープを世代間に見せる取り組み、ビジネスデザインができる人材の確保',
    },
    {
      src: '/assets/migrated/fa30cf35fbf76f7b89f1.webp',
      caption: 'WEB採用サイト ツールデザイン実績 — 富士通ネットワークソリューションズ IDカード・QRコード・クリアファイル・リーフレット「Link It All.」リアルツール 認知ツール',
    },
    {
      src: '/assets/migrated/c01fd34ca818b50d65d9.webp',
      caption: 'WEB採用サイト ツールデザイン実績 — 東苝三菱電機産業システム (TMEiC) 採用パンフレット 12P リアルツール 理解ツール — We drive industry / リクルートメントガイド（誌面）・社員インタビュー・円むそび城',
    },
    {
      src: '/assets/migrated/d8968b64eb54fb8c39ca.webp',
      caption: 'WEB採用サイト ツールデザイン実績 — 富士通株式会社 タブロイド 8P 「FUJITSU CAREER vol.01 数字とキーワードで知る富士通」 A〜Zのキーワード構成 / 社長メッセージ・言葉さがし / リアルツール 認知・理解ツール',
    },
    {
      src: '/assets/migrated/893ffe9db200276f866b.webp',
      caption: 'WEB採用サイト ツールデザイン実績 — インフォテック株式会社 採用動画制作「その一歩に挑む。」デジタル 映像動画ツール 理解ツール — 社員インタビュー 採用メッセージ動画 / アニメーションによる会社概要説明 / 金融第1統括部 千葉 大介',
    },
    {
      src: '/assets/migrated/097143f1da72cd53b1b6.webp',
      caption: 'WEB採用サイト ツールデザイン実績 — 富士通株式会社 キャリア採用サイト 「現代を担い、次代を創造する FUJITSU CAREER」 デジタル WEBツール 理解・行動ツール — 社員インタビュー・求人リスト・キャリアパス全ページ構成',
    },
    {
      src: '/assets/migrated/574462c60c80c2bfb6cb.webp',
      caption: 'WEB採用サイト ツールデザイン実績 — 富士通ネットワークソリューションズ 「Link It All.」 2020年採用サイト ワンストップソリューション ツール 理解・理解・行動ツール — バラまきツールに誘導・IDカード・リーフレット・ランディングページ・採用サイトのワンストップ展開',
    },
    {
      src: '/assets/migrated/8e1a958c2d9e586292da.webp',
      caption: '富士通様 ブランディング戦略 表紙 — 「なりたい自分になれる！を可視化するUI UX設計」 Heptagram Element と FUJITSU ロゴ',
    },
    {
      src: '/assets/migrated/545468103acf7db733e7.webp',
      caption: '富士通様 ブランディング戦略 コミュニケーション設計 — Heptagram Element の層籏構成・3D表現・7の要素詳細展開・Purposeの可視化',
    },
  ],
};

export default fujitsuRecruitCase;